// Core-schema column names as a monitor should read them. Anything unmapped
// falls back to a de-underscored form: a change must never be invisible just
// because it has no label yet.
const FIELD_LABELS: Record<string, string> = {
  // Adverse events
  adverse_event_name: "Event",
  adverse_event_standard_name: "Coded term",
  adverse_event_source_value: "Reported term",
  severity_source_value: "Severity",
  serious_adverse_event: "Serious",
  causality_source_value_derived: "Causality",
  causality_source_value_raw: "Causality (as reported)",
  outcome_source_value_derived: "Outcome",
  outcome_source_value_raw: "Outcome (as reported)",
  action_taken_source_value_derived: "Action taken",
  action_taken_source_value_raw: "Action taken (as reported)",
  adverse_event_discontinue: "Led to discontinuation",
  sae_death: "Resulted in death",
  sae_life_threatening: "Life-threatening",
  sae_hospitalization: "Hospitalisation",
  sae_significant_disability: "Significant disability",
  sae_congenital_anomaly_offspring: "Congenital anomaly",
  sae_medically_significant: "Medically significant",
  sae_special_interest: "Event of special interest",
  sae_intervention_required: "Intervention required",
  sae_description: "Narrative",
  sae_other_rationale_note: "Seriousness rationale",
  therapy_administered: "Therapy administered",
  ongoing: "Ongoing",
  start_date: "Start date",
  end_date: "End date",

  // Concomitant medications
  medication_name: "Medication",
  official_name: "Official name",
  indication_name: "Indication",
  medication_type: "Type",
  dose: "Dose",
  dose_unit_source_value: "Dose unit",
  dose_frequency: "Frequency",
  dose_route: "Route",
  stop_reason: "Stop reason",
  stop_reason_specify: "Stop reason detail",
  taken_prior_first_study_drug: "Taken before first dose",

  // Labs
  test_name: "Test",
  lab_battery: "Panel",
  reported_numeric_result: "Result",
  reported_text_result: "Result (text)",
  reported_result_unit: "Unit",
  reported_range_low: "Range low",
  reported_range_high: "Range high",
  toxicity_grade: "Toxicity grade",
  ref_range_alert_flag: "Range flag",
  test_abnormal_results: "Abnormal",
  test_clinically_significant_results: "Clinically significant",
  lab_battery_clinically_significant_comment: "Significance comment",
  lab_date: "Lab date",
  test_comments: "Comments",

  // IP administration
  administration_date: "Administration date",
  was_dose_administered: "Dose administered",
  dose_administered_per_protocol: "Per protocol",
  actual_dose_administered: "Actual dose",
  actual_dose_administered_unit: "Actual dose unit",
  entire_dose_not_administered_reason: "Dose not given — reason",
  ip_change: "Dose change",
  ip_change_reason: "Dose change reason",
  ip_change_reason_ae: "Change due to AE",
  ip_change_date: "Dose change date",
  interrupted_end_time: "Interruption start",
  interrupted_restart_time: "Interruption end",
  activity_status: "Status",

  // Protocol deviations
  protocol_deviation_code: "Deviation code",
  protocol_deviation_level: "Level",
  protocol_deviation_type_source_value: "Type",
  protocol_deviation_subtype_source_value: "Subtype",
  protocol_deviation_severity_source_value: "Severity",
  protocol_deviation_status_source_value: "Status",
  protocol_deviation_corrective_action_source_value: "Corrective action",
  identification_date: "Identified",
  close_date: "Closed",
  description: "Description",
};

export function fieldLabel(field: string): string {
  const mapped = FIELD_LABELS[field];
  if (mapped) return mapped;
  const spaced = field.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
